// @ts-nocheck
import { clsx } from 'clsx'

/**
 * @typedef {import("clsx").ClassValue} ClassValue
 */

/**
 * Utility function to deal with optional class names
 * @param {...ClassValue} inputs
 * @return {string}
 */
export const cn = (...inputs) => clsx(inputs)
